/* vk-video-lazy.js - lazy autoplay for hybrid product videos (VERKLINE 2026-04-24)
   Pattern: server renders <video preload="none"> (no autoplay, no controls).
   This script observes .vk-video-wrapper video elements and plays them when
   they enter viewport - fires once per video. Lighthouse without scroll = 0 bytes.
*/
(function(){
  if (!('IntersectionObserver' in window)) {
    // fallback: old browsers play immediately
    document.querySelectorAll('.vk-video-wrapper video').forEach(function(v){
      v.preload = 'auto'; v.play().catch(function(){});
    });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        var v = e.target;
        v.preload = 'auto';
        v.play().catch(function(){ /* autoplay may be blocked; user will see poster */ });
        io.unobserve(v);
      }
    });
  }, { rootMargin: '200px 0px', threshold: 0.1 });
  function init(){
    document.querySelectorAll('.vk-video-wrapper video').forEach(function(v){ io.observe(v); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
